import { List, Record } from "immutable";

import { defaultSectionStat, SectionStatType } from "../SectionStat";

export type ContentStatType = SectionStatType & {
  contentIds: List<string>;
};

export const defaultContentStat: ContentStatType = {
  ...defaultSectionStat,
  contentIds: List()
};

export default class ContentStat extends Record(defaultContentStat) {}
